<template>
  <div>
    <v-container>
      <h2 class="flex display-1 text-center mb-5 mt-2" style="color: #084776">Novosti e-učenja Sveučilišta u
        Mostaru</h2>
      <v-row justify="center">

        <v-col cols="12" md="4" v-for="(stavka, i) in stavke" :key="i">
          <v-card style="height: 100%;" outline>
            <div v-if="stavka.image" class="">
              <v-img
                  :src="'https://web-admin.sum.ba/api/storage/' + stavka.image"
                  height="200px"
              ></v-img>
            </div>
            <div v-else>
              <v-img
                  class="white--text"
                  height="200px"
                  :src="require('@/assets/img/sum.png')"
              >
              </v-img>
            </div>

            <v-card-title class="pb-0 title" style="color: #084776">
              <router-link :to="'/novosti/' + stavka.alias" class=" link"><a class="link"
                                                                             @click="scrollToTop()">{{ stavka.title }}</a>
              </router-link>
            </v-card-title>
            <v-card-text>
              <div>
                <span class="grey--text">{{ stavka.subtitle }}</span><br>
                <span v-html="stavka.content.slice(0, 350) + '...'"></span>
              </div>
            </v-card-text>
            <br>
            <v-card-actions class="justify-end">
              <div style="position: absolute; bottom: 10px;">
                <router-link
                    style="text-decoration:none; color: white;"
                    :to="'/novosti/' + stavka.alias"
                >
                  <v-btn @click="scrollToTop()" color="#084776" class="white--text">Više</v-btn>
                </router-link>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="8" class="mt-4">
          <a :href="eronet.video" target="_blank">
            <v-img :src="'https://web-admin.sum.ba/api/storage/' + first_image"></v-img>
          </a>
        </v-col>
      </v-row>
    </v-container>
    <v-img :src="require('@/assets/img/Cover3.png')"
           class="white--text"
           gradient="to top, rgba(13, 3, 29, .60), rgba(25, 25, 38, .30)"
    >
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="6" class=" text-center">
            <v-row>
              <v-col cols="12" class="text-left text-start">
                <v-icon color="white">fas fa-quote-right</v-icon>
              </v-col>
              <v-col cols="10"><span>Sustav za e-učenje SUMARUM omogućava nastavnicima, studentima i ustanovama na Sveučilištu
                u Mostaru izvođenje kolegija, koji se nalaze u redu predavanja pojedine ustanove, uz primjenu
                tehnologija e-učenja. SUMARUM se temelji na sustavu otvorenog koda Moodle kojeg je Centar za
                informacijske tehnologije Sveučilišta u Mostaru prilagodio potrebama korisnika.</span></v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="mt-8">
            <v-row>
              <!-- <v-col xs2><v-icon color="white">fas fa-quote-right</v-icon></v-col> -->
              <v-col cols="12">
                <h2 class="title">Preuzmite Moodle mobilnu aplikaciju</h2>
                <p class="pt-2">Pomoću aplikacije Moodle možete učiti gdje god se nalazite i kad god želite.</p>
                <ul>
                  <li>Jednostavno pristupite sadržaju tečaja</li>
                  <li>Povežite se s polaznicima e-kolegija</li>
                  <li>Budite u tijeku svih događanja na e-kolegiju</li>
                  <li>Pošaljite zadatke - s mobilnog uređaja prenesite slike, audio, video zapise i druge datoteke</li>
                </ul>
                <v-row class="pt-2 hidden-sm-and-down" align="center">
                  <v-col cols="4">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.moodle.moodlemobile"
                        width
                        target="_blank"
                    >
                      <v-img :src="require('@/assets/img/gplay.svg')"></v-img>
                    </a>
                  </v-col>
                  <v-col cols="2"></v-col>
                  <v-col cols="4">
                    <a
                        href="https://itunes.apple.com/app/moodle-mobile/id633359593?mt=8"
                        target="_blank"
                    >
                      <v-img :src="require('@/assets/img/appstore.svg')"></v-img>
                    </a>
                  </v-col>
                </v-row>
                <v-row class="pt-2 hidden-md-and-up" align="center">
                  <v-col cols="8" class="mb-2">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.moodle.moodlemobile"
                        width
                        target="_blank"
                    >
                      <v-img :src="require('@/assets/img/gplay.svg')"></v-img>
                    </a>
                  </v-col>
                  <v-col cols="8">
                    <a
                        href="https://itunes.apple.com/app/moodle-mobile/id633359593?mt=8"
                        target="_blank"
                    >
                      <v-img :src="require('@/assets/img/appstore.svg')"></v-img>
                    </a>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-container class="my-6">
      <v-row>
        <v-col cols="6" sm="3">
          <v-img :src="require('@/assets/img/eduID_color.svg')"></v-img>
        </v-col>
        <v-col cols="12" sm="9">
          <h2 style="color: #084776">eduID</h2>
          <p class="pt-2">Autentikacijska i autorizacijska infrastruktura je infrastrukturni, posrednički sustav čija je
            temeljna zadaća omogućiti sigurno, pouzdano i efikasno upravljanje elektroničkim identitetima te njihovu
            uporabu za pristup mrežnim i mrežom dostupnim resursima. Autentikacijska i autorizacijska infrastruktura u
            sustavu znanosti i visokog obrazovanja na Sveučilištu u Mostaru svoje polazište koncepcijski ima u
            distribuiranom sustavu imenika utemeljenih na LDAP standardu. Nadležnost nad imeničkim podacima o fizičkim i
            pravnim osobama, te informacijskim i drugim resursima imaju njihove matične ustanove iz sustava znanosti i
            visokog obrazovanja</p>
          <a href="https://eucenje.sum.ba/moodle/login/login.php" class="link">U sustav za e-učenje se možete prijaviti
            s eduID elektoriničkim identitetom.</a>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import axios from "axios";
import {serverBus} from "../main";

export default {
  async mounted() {
    serverBus.$emit("news-change", this.$route.params.alias);
    this.alias = this.$route.params.alias;
    this.getNovosti()
    this.getEronetBanner()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    navigate: function (link) {
      let self = this;
      // serverBus.$emit('aaa')
      localStorage.setItem("centri", link);

      setTimeout(function () {
        self.$router.push(link);
      }, 120);

      window.scrollTo(0, 0);
    },

    getEronetBanner() {
      let requestBody = {
        alias: "eronet-banner-sponzorstvo"
      };
      axios
          .post("https://web-admin.sum.ba/api/web/objava", requestBody)
          .then(response => {
            this.eronet = response.data;

            this.first_image = this.eronet.images.find(Boolean)
          })
          .catch(error => console.log(error.message));
    },
    getNovosti() {
      let requestBody = {
        page: 1,
        postsPerPage: 3,
        categories: ["E-učenje"],
      };

      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.stavke = response.data;
          })
          .catch(error => console.log(error.message));
    }
  },
  data: () => ({
    stavke: [],
    eronet: {},
    first_image: ''
  })
}
</script>

<style>

</style>
